// extracted by mini-css-extract-plugin
export default {"loginPage_container":"LoginPage_loginPage_container__Ok-9l","login_image":"LoginPage_login_image__g-VJX"};